<div class="mep-dialog-header-icon">
	<mat-icon> directions </mat-icon>
</div>
<div class="mep-dialog-title">{{ _lang("navigation") }}</div>
<div class="mep-dialog-content" mat-dialog-content>
	<mat-nav-list>
		@for (navigation of data; track navigation) {
			<a [href]="navigation.value" mat-list-item target="_blank" rel="noopener">
				<mat-icon color="primary" mat-list-icon> download </mat-icon>
				{{ navigation.viewValue }}
			</a>
		}
	</mat-nav-list>
</div>

<div class="mep-dialog-actions">
	<button (click)="onCloseClick()" appEscapeHotkey class="mep-btn-dialog-secondary">{{ _lang("cancel") }}</button>
</div>
